import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.prepasrel').directive('validateWorkflowName', function() {
        return {
            restrict: 'A',
            require: 'ngModel',

            link: function(scope, element, attributes, ngModel) {
                ngModel.$validators.workflowNamePattern = function(modelValue) {
                    var maxLength = !!modelValue && modelValue.length <= 32;
                    var test = /^[a-zA-Z0-9_]{1,}$/.test(modelValue);
                    return maxLength && test;
                };
            }
        };
    });
})();
